var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 399,
    viewBox: "0 0 674 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1384)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 674,
    height: 399,
    rx: 26,
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 79,
    r: 35,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 332.884,
    width: 153.995,
    height: 145.626,
    rx: 11,
    transform: "rotate(-44.9964 402 332.884)",
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.805,
    y: 331.189,
    width: 65.6019,
    height: 62.0365,
    rx: 11,
    transform: "rotate(-44.9964 462.805 331.189)",
    fill: "#FDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 61.5,
    r: 79.5,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 155,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 253,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 155,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 253,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 155,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 253,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 171,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 269,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 171,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 269,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 674,
    height: 399,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingBg);
export default __webpack_public_path__ + "static/media/onboarding_bg.da530dc1043128525b7d1be1c8373078.svg";
export { ForwardRef as ReactComponent };